import React from "react";
import { observer } from "mobx-react";
import { ShufflePreviewTemplate } from "themes/administration/shuffle/pages";
import { ShufflePreviewViewStore } from "administration/shuffle/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) =>
        new ShufflePreviewViewStore(rootStore, componentProps),
    "shufflePreviewViewStore"
)
@observer
class ShufflePreview extends React.Component {
    render() {
        return <ShufflePreviewTemplate {...this.props} />;
    }
}

export default ShufflePreview;
